<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-row class="searchSection">
                <SearchForm 
                :params="searcheModel" 
                :fields="fields" 
                :cache_field="'search_config_' + active_name + '_' + this.$route.path" 
                @search="submitSearch" 
                @reset="resetForm" 
                :key="search_form_key"> 
                </SearchForm>
            </el-row>
            <el-row class="addBtn">
                <el-button @click="updateStatus" type="info" size="small" :disabled="multipleSelection.length == 0">设置物流状态</el-button>
                <ExportFile 
                    url="/api/export/logistics-list" 
                    :params="searcheModel" 
                    filename="全部快递" 
                    buttonName="导出Excel">
                </ExportFile>
                <ImportFile 
                    templateFileUrl="/api/export/order-logistics-template" 
                    url="/api/import/order-logistics"  
                    dialogTitle="导入物流信息" 
                    buttonText="导入物流信息+"
                    buttonType="success" 
                    :err_fields="err_fields" 
                    @import_success="submitSearch()"
                    >
                </ImportFile>
            </el-row>
            <el-row v-loading="loading">
                <el-table :data="list" border max-height="650" @selection-change="handleSelectionChange" v-loading="loading">
                    <el-table-column type="selection" width="50"></el-table-column>
                    <el-table-column prop="id" label="寄件ID" width="80"></el-table-column>
                    <el-table-column prop="order_id" label="订单ID" width="70">
                        <template slot-scope="scope">
                            <el-button @click="handleView(scope.row)" type="text" size="small">{{scope.row.order_id}}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="customer_name" label="客户名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button @click="handleCustomerView(scope.row)" type="text" size="small">{{scope.row.customer_name}}</el-button>
                        </template>
                    </el-table-column>
                     <el-table-column prop="user_name" label="订单负责人" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="goods_type_str" label="寄件类型" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="send_at" label="寄出日期" width="100"></el-table-column>
                    <el-table-column prop="express_content" label="寄件备注" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="express_name" label="收货人" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="express_mobile" label="收货手机" width="110"></el-table-column>
                    <el-table-column prop="express_address" label="收货地址" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="send_type_str" label="送达方式" width="80"></el-table-column>
                    <el-table-column prop="send_way_str" label="寄件快递" width="110" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="express_way_str" label="寄件方式" width="80"></el-table-column>
                    <el-table-column prop="express_no" label="快递单号" width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="send_status_str" label="发货状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.send_status == 0" type="info" :underline="false">{{scope.row.send_status_str}}</el-link>
                            <el-link v-else-if="scope.row.send_status == 1" type="danger" :underline="false">{{scope.row.send_status_str}}：{{scope.row.send_memo}}</el-link>
                            <el-link v-else-if="scope.row.send_status == 2" type="success" :underline="false">{{scope.row.send_status_str}}</el-link>
                            <span v-else>{{scope.row.send_status_str}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="express_status_str" label="签收状态" width="80"></el-table-column>
                    <el-table-column prop="operate" label="操作" fixed="right" width="120">
                        <template slot-scope="scope">
                            <div>
                                <el-button type="text" v-if="Acs('/order/add-sending')" @click="editContent(scope.row)" size="small">编辑内容</el-button>
                                <el-button type="text" v-if="Acs('/order/add-sending')" @click="deleteLogistic(scope.row)" size="small">删除</el-button>
                            </div>
                            <div>
                                <el-button type="text" v-if="Acs('/order/add-logistics') && scope.row.send_type != 2" @click="editLogistic(scope.row)" size="small">录入物流信息</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
            </el-row>
            <LogisticsForm v-if="dialog_type > 0" 
                :dialog_type="dialog_type" 
                :params="logisticsForm" 
                @updateChange="handleUpdate" 
                @addChange="handleAdd" 
                @close="handleCloseDialog">
            </LogisticsForm>
        </div>
    </div>
</template>
<script>
import OrderService from "~/services/order";
import SearchForm from "~/widgets/SearchForm.vue";
import MyPagination from "~/widgets/MyPagination.vue";
import ExportFile from "~/widgets/ExportFile.vue";
import LogisticsForm from "~/views/order/dialog/LogisticsForm.vue";
import ImportFile from "~/widgets/ImportFile.vue";
export default {
    name: "logistics",

    components: {
        SearchForm,
        MyPagination,
        ExportFile,
        LogisticsForm,
        ImportFile
    },

    props: {},

    data() {
        return {
            loading: false,
            searcheModel: {},
            // 分页信息
            linkPage: null,
            list: [],
            fields: [],
            search_form_key: 0,
            active_name: 'logistics',
            dialog_visible: false,
            model: {},
            show_type: '',
            dialog_type: 0,
            logisticsForm: {},
            err_fields:{
                line_num: '行数',
                error_str: '异常原因',
                id: '寄件ID',
                order_id: '订单ID',
                customer_name: '客户名称',
                send_type: '送达方式',
                send_at: '寄出日期',
                express_way: '寄件方式',
                express_no: '快递单号',
                send_status: '发货状态',
                express_status: '签收状态',
            },
            multipleSelection: []
        };
    },

    mounted() {},

    /**
     * 监听组件切换变化
     */
    watch: {
        $route(to, from) {
            this.resetForm();
        },
        multipleSelection: function (value, oldValue) {
            if (value.length > 0) {
                this.disableBatchOption = false;
            } else {
                this.disableBatchOption = true;
            }
        },
    },

    created() {
        this.resetForm();
    },

    methods: {
        //重置按钮
        resetForm() {
            this.fields = [
                {field: 'base', label: '基础信息筛选条件', children: [
                    {field: 'customer_name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
                    {field: 'order_id', label: '订单ID', type: 'input'},
                    {field: 'send_status', label: '发货状态', type: 'select', list: [{value: '', label: '不限'}, {value: 2, label: '全部发货'}, {value: 1, label: '部分发货'}, {value: 0, label: '待发货'}]},
                    {field: 'express_status', label: '签收状态', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '已签收'}, {value: 0, label: '未签收'}]},
                ]},
                {field: 'date', label: '时间筛选条件', children: [
                    {field: 'send_time', label: '寄出日期', type: 'daterange'},
                ]},
            ];
            this.searcheModel = {
                active_name: this.active_name,
                user_id: this.$router.currentRoute.path == '/order/my-logistics' ? this.$store.getters.userId : '',
            };
            this.list = [];
            this.search_form_key ++;
            this.submitSearch();
        },

        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            //请求侧边栏地区树
            this.getList(params);
        },

        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            OrderService.logisticsList(params).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },


        editLogistic(row){
            this.logisticsForm = Object.assign(this.logisticsForm, row);
            if(this.logisticsForm.express_way == 0) this.logisticsForm.express_way = '';
            this.dialog_type = 1;
        },

        editContent(row){
            this.logisticsForm = Object.assign(this.logisticsForm, row);
            this.dialog_type = 2;
        },

        deleteLogistic(item){
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                OrderService.logisticsDel(item.id).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submitSearch();
                    }
                })
            }).catch(() => {
            });
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.submitSearch();
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.submitSearch();
        },
        
        handleView(row) {
            let routeData = this.$router.resolve({
                path: "/order/view",
                query: {id: row.order_id},
            });
            window.open(routeData.href, '_blank');
        },

        handleCustomerView(row){
            let routeData = this.$router.resolve({
                path: "/customers/view",
                query: {id: row.customer_id},
            });
            window.open(routeData.href, '_blank');
        },

        handleAdd(data){
            this.submitSearch();
        },

        handleUpdate(data){
            // 查找需要更新的物流信息的索引
            let index = this.list.findIndex(i => i.id === data.id);

            // 如果找到了，就更新该物流信息
            if (index !== -1) {
                // 使用 this.$set 确保响应性更新
                this.$set(this.list, index, { ...this.list[index], ...data });
            }
        },
        
        handleCloseDialog(){
            this.dialog_type = 0;
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        updateStatus() {
            this.logisticsForm.ids = this.multipleSelection.map(item => item.id);
            this.dialog_type = 3;
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/views/order/logistics.vue